var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent'),_vm._v(" "),_c('div',{staticClass:"router__container"},[_c('router-view',{staticClass:"content",class:{ 'safe-bottom-space': _vm.$route.name !== 'Legal' }})],1),_vm._v(" "),_c('FooterComponent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89f20f6a","hasScoped":false,"transformToRequire":{"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = giQR
// module chunks = 1